const isAdmin = me => me.account.pobbler_type && me.account.pobbler_type.admin

export { isAdmin }
